import {create} from 'zustand';
import {ListBankTransactionsResponse, PSPType} from './types';
import {downloadAccountStatement, listBankTransactions} from './ApiHelper';
import {getStorageItem, putStorageItem, StorageKeys} from './StorageHelper';
import {startOfDay, startOfMonth, startOfQuarter, startOfWeek, startOfYear} from 'date-fns';

export interface BankTransactionState {
  loading: boolean;
  response: ListBankTransactionsResponse;
  hasErrors: boolean;
  psp: PSPType;
  setPsp: (psp: PSPType) => Promise<void>;
  refresh: (force?: boolean) => void;
  downloadAccountStatement: () => Promise<any>;
  reset(): void;
}

async function getStateDate() {
  const since = await getStorageItem(StorageKeys.UI_LEDGER_SINCE);

  let startDate;
  if (since === 'quarter') {
    startDate = startOfQuarter(new Date());
  } else if (since === 'year') {
    startDate = startOfYear(new Date());
  } else if (since === 'month') {
    startDate = startOfMonth(new Date());
  } else if (since === 'week') {
    startDate = startOfWeek(new Date());
  } else if (since === 'day') {
    startDate = startOfDay(new Date());
  }
  return startDate;
}

async function getStatePsp() {
  const psp = await getStorageItem(StorageKeys.UI_LEDGER_PSP);
  return psp;
}

const UseBankTransactionStore = create<BankTransactionState>((set) => {
  return {
    loading: true,
    response: null,
    hasErrors: false,
    psp: '',
    setPsp: async (psp: PSPType) => {
      await putStorageItem(StorageKeys.UI_LEDGER_PSP, psp);
    },
    downloadAccountStatement: async () => {
      let startDate = await getStateDate();
      return downloadAccountStatement(startDate, new Date());
    },
    refresh: async () => {
      set(() => ({loading: true}));
      try {
        let startDate = await getStateDate();
        let psp = await getStatePsp();
        const bankTransactionsResponse = await listBankTransactions(startDate, new Date(), psp);
        set(() => ({response: bankTransactionsResponse, loading: false, hasErrors: false, psp}));
      } catch (err: any) {
        set(() => ({response: null, loading: false, hasErrors: true}));
        throw err;
      }
    },
    reset: () => {
      set(() => ({
        loading: false,
        response: null,
        hasErrors: false,
      }));
    },
  };
});

export default UseBankTransactionStore;
